import BaseService from '_services/rest/base';

class WordService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/word`;
  }

  deleteWord(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'delete')
      .catch(err => {
        throw err;
      });
  }

  getWords(params) {
    const skip = params.skip ? params.skip : 0;
    const take = params.take ? params.take : 10;
    const search = params.search ? params.search : null;
    const letter = params.letter ? params.letter : null;
    return this.request(`${this.getUrl()}/all/${skip}/${take}`, { search, letter })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    return this.request(`${this.getUrl()}`, model, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new WordService();
